import { CIcon } from '~/icons/types'

export const ciDenied: CIcon = {
  width: 20,
  height: 20,
  paths: [
    {
      d:
        'M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0ZM3.493 4.777A8.31 8.31 0 0 0 1.655 10 8.349 8.349 0 0 0 10 18.345a8.308 8.308 0 0 0 5.223-1.838L3.492 4.777Zm12.937 10.54A8.31 8.31 0 0 0 18.345 10 8.349 8.349 0 0 0 10 1.655c-2.02 0-3.872.72-5.317 1.915L16.43 15.317Z',
      fill: '#fff'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'denied',
  type: 'regular'
}
